module.exports = __webpack_public_path__ + "static/media/successBig.9bd6635e.svg";